import {Col, ListGroup, ListGroupItem, Row} from "reactstrap";
import classes from "../PostList.module.css";
import React from "react";
import {Link} from "react-router-dom";
import {faBookmark, faComment, faThumbsDown, faThumbsUp, faUserCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {timeStampToPostString, articleContentLangWithLimit} from "../../../Utils/converter";


const PostMini = (props) => {
    return (
        <ListGroupItem className={classes.ListGroupItemMini}>
            <Link to={{
                pathname: '/post/' + props.data.id,
                state: {post: props.data}
            }}>

                <div className={classes.UserIcon}>
                    <FontAwesomeIcon icon={faUserCircle}/> User
                </div>
                <div className={classes.Date}>
                    {timeStampToPostString(props.data.createDate.seconds)}
                </div>

                <div className={classes.PostTitle}>
                    {articleContentLangWithLimit(props.data.title)}
                </div>

                <div className={classes.PostAction}>
                    {
                        props.data.numOfReview > 0 &&
                        <div className={classes.PostActionItem}>
                            <FontAwesomeIcon icon={faComment} className={classes.ThumbsUp}/>
                            <span>{props.data.numOfReview}</span>
                        </div>
                    }
                    {
                        props.data.likeCount - props.data.dislikeCount > 0 ?
                            <div className={classes.PostActionItem}>
                                <FontAwesomeIcon icon={faThumbsUp} className={classes.ThumbsUp}/>
                                <span>{props.data.likeCount - props.data.dislikeCount}</span>
                            </div>
                            :
                            props.data.likeCount - props.data.dislikeCount < 0 ?
                                <div className={classes.PostActionItem}>
                                    <FontAwesomeIcon icon={faThumbsDown} className={classes.ThumbsUp}/>
                                    <span>{props.data.likeCount - props.data.dislikeCount}</span>
                                </div>
                                :
                                <div className={classes.PostActionItem}>

                                </div>
                    }
                </div>
            </Link>
        </ListGroupItem>
    )
}
export default PostMini